/**
 * WebConsoleProvider - Logs to browser console with readable format
 */

import type { WebLogProvider, WebLogEntry } from '../types';
import { LogLevel } from '../types';

const LEVEL_COLORS: Record<LogLevel, string> = {
  [LogLevel.ERROR]: 'color: #ff4444; font-weight: bold',
  [LogLevel.WARN]: 'color: #ff8800; font-weight: bold',
  [LogLevel.INFO1]: 'color: #4488ff',
  [LogLevel.INFO2]: 'color: #6699cc',
  [LogLevel.INFO3]: 'color: #888888',
  [LogLevel.DEBUG]: 'color: #aaaaaa',
};

export class WebConsoleProvider implements WebLogProvider {
  name = 'web-console' as const;

  log(entry: WebLogEntry): void {
    const ts = new Date(entry.timestamp);
    const time = ts.toLocaleTimeString('en-US', { hour12: false }) + '.' + String(ts.getMilliseconds()).padStart(3, '0');
    const prefix = `[${time}] [${entry.levelName}] [${entry.componentName}]`;
    const opStr = entry.operation ? ` (${entry.operation})` : '';
    const style = LEVEL_COLORS[entry.level] || '';

    const args: unknown[] = [`%c${prefix}${opStr} ${entry.message}`, style];

    if (entry.data && Object.keys(entry.data).length > 0) {
      args.push(entry.data);
    }

    if (entry.error) {
      args.push(entry.error);
    }

    switch (entry.level) {
      case LogLevel.ERROR:
        console.error(...args);
        break;
      case LogLevel.WARN:
        console.warn(...args);
        break;
      case LogLevel.DEBUG:
        console.debug(...args);
        break;
      default:
        console.log(...args);
        break;
    }
  }
}
